import { CUSTOMIZE, type CustomizeAction } from '../actions/customizeActions';

export type ExperimentInfo = {
  qualified: boolean;
  variation: string;
};
export type CustomizeState = {
  lastQuestionId: string | null;
  fetchingLastQuestionId: boolean;
  experimentInfo: ExperimentInfo;
  error: string | null;
};

export const customizeInitialState = {
  lastQuestionId: null,
  fetchingLastQuestionId: false,
  experimentInfo: {
    qualified: false,
    variation: 'CONTROL',
  },
};

export function customizeReducer(
  state = customizeInitialState,
  action: CustomizeAction,
): CustomizeState {
  switch (action.type) {
    case CUSTOMIZE.REQUEST_LAST_QUESTION: {
      return {
        ...state,
        fetchingLastQuestionId: true,
      };
    }
    case CUSTOMIZE.RECEIVE_LAST_QUESTION_SUCCESS: {
      return {
        ...state,
        fetchingLastQuestionId: false,
        lastQuestionId: action.lastQuestionId,
        experimentInfo: action.experimentInfo,
      };
    }
    case CUSTOMIZE.RECEIVE_LAST_QUESTION_ERROR: {
      return {
        ...state,
        fetchingLastQuestionId: false,
        error: action.error,
      };
    }
    default: {
      return state;
    }
  }
}

export default customizeReducer;
